import React, { Component } from 'react';
import setupRelayEnvironment from 'helper/relayEnvironment';
import ChannelCardPopupDark from 'learner/views/DarkChannel/components/ChannelCardPopupNewDark/RootChannelCardPopupDark';

setupRelayEnvironment();
class CourseSharePreview extends Component {
  getCompleteLibrary = () => window.parent.getChannelPostData();

  render() {
    const channelPostData = this.getCompleteLibrary();

    const match = {
      params: {
        channelId: channelPostData[0].pid,
        cardId: channelPostData[0].approvedChannelCards[0].pid,
        type: 'dark'
      }
    };

    return (
      <ChannelCardPopupDark
        isPreview={true}
        completeLibrary={channelPostData}
        match={match}
        test={123}
        params={{ type: 'dark' }}
      />
    );
  }
}

export default CourseSharePreview;
